module.exports = __webpack_public_path__ + "static/img/icon-DOL.c22f266.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-DOL.svg
// module id = frLP
// module chunks = 0